import React from 'react'
import { ICapability } from '../../../types/capability'
import { H2 } from '../../../components'
import { CapabilitiesTableHead } from './CapabilitiesTableHead'
import { CapabilitiesTableRow } from './CapabilitiesTableRow'
import { StyledTable } from './styled'

export interface ICapabilitiesTable {
  list: ICapability[]
}

export const CapabilitiesTable = ({ list }) => (
  <>
    <H2 ml={2}>Capabilities</H2>
    <StyledTable>
      <CapabilitiesTableHead />
      <tbody>
        {list.map((capability, index) => (
          <CapabilitiesTableRow key={index} capability={capability} />
        ))}
      </tbody>
    </StyledTable>
  </>
)
